<div class="tabs-content">
    <ul class="nav nav-tabs">
        <li class="nav-item" *ngFor="let tab of tabs; let i = index">
            <button class="btn ttu" [class.active]="i === selectedTabIndex" (click)="selectTab(i)" [innerHTML]="tab.name"></button>
        </li>
    </ul>

    <div *ngIf="tabs.length > selectedTabIndex" class="tab-content">
        <div *ngFor="let content of tabs[selectedTabIndex].children; let j = index">
            <!-- {{content.definitionId}} -->
            <div [ngSwitch]="content.definitionId">
                <piece-text
                    [element]="element.children[selectedTabIndex].children[j]"
                    [direction]="direction"
                    *ngSwitchCase="'piece-text'"
                    [resolution]="resolution"
                ></piece-text>
                <piece-button
                    [element]="element.children[selectedTabIndex].children[j]"
                    [direction]="direction"
                    *ngSwitchCase="'piece-button'"
                    [resolution]="resolution"
                ></piece-button>
                <piece-product-carousel
                    [element]="element.children[selectedTabIndex].children[j]"
                    [direction]="direction"
                    *ngSwitchCase="'piece-product-carousel'"
                    [resolution]="resolution"
                ></piece-product-carousel>
            </div>
        </div>
    </div>
</div>
